/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type UtilisateurType from '@/types/Utilisateur';

type UtilisateurStoreType = {
  utilisateur: null | UtilisateurType;
  setUtilisateur: (utilisateur: UtilisateurType) => void;
};

const fakeConnectedUtilisateur: UtilisateurType = {
  identifiant: 1000,
  login: 'axel.morlet',
  nom: 'MORLET',
  prenom: 'Axel',
  email: 'axel.morlet@jvs.fr',
  profil: {
    identifiant: 1,
    nom: 'Administrateur',
    administrateur: true,
    gamme: 'horizon',
  },
};

const useUtilisateurStore = create<UtilisateurStoreType>()(
  devtools((set) => ({
    utilisateur:
      process.env.NODE_ENV === 'development' ? fakeConnectedUtilisateur : null,
    setUtilisateur: (utilisateur) => set({ utilisateur }),
  })),
);

export default useUtilisateurStore;
